
import React from 'react';

import Injemoldiplastic from './Injemoldiplastic';
import Bjstandard from './Bjstandard';


const InjePlasticbottlec = () => {
    return (
        <div>
            <Injemoldiplastic />
            <Bjstandard />
        </div>
    );
};

export default InjePlasticbottlec;
